import { DOC_CHAT, DOC_COMPARE } from '../../Constants/commonConstants';

const PRODUCT_FEATURES = {
  [DOC_CHAT]: [
    {
      key: 'workflow',
      label: 'Workflow',
      path: 'docchat/workflow',
      id: 'workflow-setting',
    },
    // Future DocChat features can be added here
    // {
    //   key: 'playbook',
    //   label: 'Playbook',
    //   path: 'docchat/playbook',
    // },
  ],
  [DOC_COMPARE]: [
    // Future DocCompare features can be added here
    // {
    //   key: 'playbook',
    //   label: 'Playbook',
    //   path: 'doccompare/playbook',
    // },
  ],
};

export const getProductFeatures = (product) => {
  return PRODUCT_FEATURES[product] || [];
};
